// extracted by mini-css-extract-plugin
module.exports = {"calendarFrameWrapper":"CalendarFrame_calendarFrameWrapper__2TDoj","hideLink":"CalendarFrame_hideLink__2RUwa","background":"CalendarFrame_background__1FNwm"};